"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var instant_meilisearch_1 = require("@meilisearch/instant-meilisearch");
/** Meilisearch client. */
var Client = /** @class */ (function () {
    /** Constructing client. */
    function Client(url, key) {
        this.url = url;
        this.key = key;
        this.client = (0, instant_meilisearch_1.instantMeiliSearch)(this.url, this.key).MeiliSearchClient;
    }
    /** Getting underlying client */
    Client.prototype.getClient = function () {
        return this.client;
    };
    /**
     * Starting a search request.
     * @param index Where to search.
     * @param searching Search value.
     * @param filters Filters to apply.
     * @returns Search results.
     */
    Client.prototype.search = function (index, searching, params) {
        var _a;
        return this.client
            .index(index)
            .search(searching, __assign(__assign({}, params), { filter: (_a = params === null || params === void 0 ? void 0 : params.filter) === null || _a === void 0 ? void 0 : _a.format() }));
    };
    return Client;
}());
exports.default = Client;
